<template>
    <div class="containerDebitDetail" :style="corPrimaria">
        <div v-if="!enviarProposta &&
        !receberLigacao &&
        !contatoDigital &&
        parceiro != 'uol'
        " class="row-options-buttons">
            <div style="width: 100%">
                <button-default v-if="!parceiroConfig.sessoes.customization.campos.myDebits
        .flgDesativarEnviarProposta
        " :style="'width: 100%'" :color="parceiroConfigCorSecundariaCorPrimaria" :secondary-color="true"
                    @click.native="enviarProposta = true" text="Envie sua proposta"></button-default>
            </div>
        </div>

        <template v-if="enviarProposta || parceiro == 'uol'">
            <send-proposal :divida="divida" @close="enviarProposta = false"></send-proposal>
        </template>

        <template v-else-if="parceiro != 'uol'">
            <template v-if="parcelaSelected === null">
                <div id="div-data-primeiro-vencimento">
                    <h3>Data do primeiro vencimento</h3>

                    <input id="input-data-primeiro-vencimento" v-model="primeiroVencimento" :style="{
        color: parceiroConfig.estilo.corPrimaria,
        'border-color': parceiroConfig.estilo.corPrimaria,
    }" :min="dataDeHoje" :max="dataLimite" type="date" pattern="[0-9]{2}/[0-9]{2}/[0-9]{4}" />

                    <button-default @click.native="buscarNegociacoes" style="margin-top: 20px"
                        :text="'Recalcular'"></button-default>
                </div>

                <h3>Qual a forma de pagamento?</h3>

                <div class="row-tabs">
                    <label class="tab left" :style="aVistaOuAPrazo === 'A'
        ? {
            color: parceiroConfig.estilo.corPrimaria,
            borderColor:
                parceiroConfig.estilo.corPrimaria,
        }
        : 'var(primaryColor)'
        ">
                        <input v-model="aVistaOuAPrazo" type="radio" id="a_vista" value="A" class="hide" checked />
                        À vista</label>

                    <label class="tab right" :style="aVistaOuAPrazo === 'P'
        ? {
            color: parceiroConfig.estilo.corPrimaria,
            borderColor:
                parceiroConfig.estilo.corPrimaria,
        }
        : 'var(primaryColor)'
        ">
                        <input v-model="aVistaOuAPrazo" type="radio" id="a_prazo" value="P" class="hide" />
                        À Prazo</label>
                </div>

                <h3>Você quer pagar por?</h3>

                <div class="row-tabs">
                    <label class="tab left" :style="typePayment === 'boleto'
        ? {
            color: parceiroConfig.estilo.corPrimaria,
            borderColor:
                parceiroConfig.estilo.corPrimaria,
        }
        : 'var(primaryColor)'
        ">
                        <input id="boleto" v-model="typePayment" type="radio" value="boleto" class="hide" />
                        Boleto</label>

                    <label v-if="!parceiroConfig.sessoes.customization.campos
        .myDebits.flgDesativarPix
        " class="tab" :style="typePayment === 'pix'
        ? {
            color: parceiroConfig.estilo.corPrimaria,
            borderColor:
                parceiroConfig.estilo.corPrimaria,
        }
        : 'var(primaryColor)'
        ">
                        <input id="pix" v-model="typePayment" type="radio" value="pix" class="hide" />
                        PIX</label>

                    <label v-if="!parceiroConfig.sessoes.customization.campos
        .myDebits.flgDesativarCartaoCredito
        " class="tab right" :style="typePayment === 'cartao'
        ? {
            color: parceiroConfig.estilo.corPrimaria,
            borderColor:
                parceiroConfig.estilo.corPrimaria,
        }
        : 'var(primaryColor)'
        ">
                        <input id="cartao" v-model="typePayment" type="radio" value="cartao" class="hide" />
                        Cartão de Crédito</label>
                </div>

                <div class="container-option-payment">
                    <h3>SELECIONE A QUANTIDADE DAS PARCELAS QUE VOCÊ QUER PAGAR</h3>

                    <h4 v-if="typePayment == 'cartao'">Valor informado das parcelas abaixo, terá acréscimos dos juros cobrado pela operadora de cartão de crédito, sendo esse acréscimo por conta do cliente</h4>

                    <monthly-payment-card v-for="parcela in parcelas" :key="parcela.pra_codigo"
                        :typePayment="typePayment" :parcela="parcela" :divida="divida"
                        @click.native="parcelaSelected = parcela"></monthly-payment-card>

                    <h6 class="message-empty" v-if="parcelas === 0">
                        {{ mensagemNegociacoesNaoEncontradas }}
                    </h6>
                </div>
            </template>

            <details-monthly-payment v-else :parcela="parcelaSelected" :divida="divida" :tipoPagamento="typePayment"
                :aVistaOuAPrazo="aVistaOuAPrazo" @backOption="parcelaSelected = null"></details-monthly-payment>
        </template>
    </div>
</template>

<script>
    import { mapState, mapMutations, createNamespacedHelpers } from "vuex";
    import globalMethods from "@/mixins/globalMethods";
    import mixins from "@/mixins/mixins";

    import ButtonDefault from "@/components/buttons/ButtonDefault";
    import DetailsMonthlyPayment from "./DetailsMonthlyPayment";
    import Template from "@/views/admin/Template";
    import MonthlyPaymentCard from "./MonthlyPaymentCard";
    import SendProposal from "./SendProposal";
    import ReceiveCall from "./ReceiveCall";
    import DigitalContact from "./DigitalContact";

    const { mapActions: mapActionsPassosRetornarDividas } = createNamespacedHelpers(
        "passosRetornarDividas"
    );

    let dataAtual = new Date();
    let dia =
        dataAtual.getDate() > 9 ? dataAtual.getDate() : `0${dataAtual.getDate()}`;
    let mes =
        dataAtual.getMonth() + 1 > 9
            ? dataAtual.getMonth() + 1
            : `0${dataAtual.getMonth() + 1}`;
    dataAtual = `${dataAtual.getFullYear()}-${mes}-${dia}`;

    export default {
        name: "PaymentOptionsDebit",

        components: {
            DigitalContact,
            ReceiveCall,
            SendProposal,
            MonthlyPaymentCard,
            Template,
            DetailsMonthlyPayment,
            ButtonDefault,
        },

        mixins: [globalMethods, mixins],

        props: {
            divida: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                typePayment: "boleto",
                parcelaSelected: null,
                enviarProposta: false,
                receberLigacao: false,
                contatoDigital: false,
                parcelas: [],
                parcelasAvista: [],
                parcelasPrazo: [],
                aVistaOuAPrazo: "A",
                preCodigo: [],
                primeiroVencimento: dataAtual,
                primeiroVencimentoAnterior: dataAtual,
            };
        },

        computed: {
            ...mapState({
                escolhaFiltro: (estado) => estado.escolhaFiltro,
                corPrimaria: (estado) => estado.corPrimaria,
                corSecundaria: (estado) => estado.corSecundaria,
                formaPagamento: (estado) => estado.formaPagamento,
                formaPagamentoChar: (estado) => estado.formaPagamentoChar,
            }),

            dataLimite() {
                let dataAgoraEmMilisegundos = Date.now();
                let milisegundosDataLimite =
                    this.divida.loja.prazo_maximo_entrada_site * 86400000;
                let dataLimite = new Date(
                    dataAgoraEmMilisegundos + milisegundosDataLimite
                );
                let dia =
                    dataLimite.getDate() > 9
                        ? dataLimite.getDate()
                        : `0${dataLimite.getDate()}`;
                let mes =
                    dataLimite.getMonth() + 1 > 9
                        ? dataLimite.getMonth() + 1
                        : `0${dataLimite.getMonth() + 1}`;
                return `${dataLimite.getFullYear()}-${mes}-${dia}`;
            },

            dataDeHoje() {
                const dataAgora = new Date();
                let dia =
                    dataAgora.getDate() > 9
                        ? dataAgora.getDate()
                        : `0${dataAgora.getDate()}`;
                let mes =
                    dataAgora.getMonth() + 1 > 9
                        ? dataAgora.getMonth() + 1
                        : `0${dataAgora.getMonth() + 1}`;
                return `${dataAgora.getFullYear()}-${mes}-${dia}`;
            },

            tituloListaDePagamentos() {
                return this.divida.length === 0
                    ? "Esta opção de pagamento não está disponível!"
                    : "Selecione o valor e a quantidade das parcelas que você quer pagar";
            },

            mensagemNegociacoesNaoEncontradas() {
                let mensagemNegociacoesNaoEncontradas =
                    "Nenhuma opção de pagamento encontrada para a forma";
                switch (this.typePayment) {
                    case "boleto":
                        mensagemNegociacoesNaoEncontradas += "boleto";
                        break;

                    case "pix":
                        mensagemNegociacoesNaoEncontradas += "pix";
                        break;

                    case "cartao":
                        mensagemNegociacoesNaoEncontradas += "cartao";
                        break;
                }
                return mensagemNegociacoesNaoEncontradas;
            },
        },

        watch: {
            aVistaOuAPrazo() {
                this.SET_FORMA_PAGAMENTO_CHAR(this.aVistaOuAPrazo);
                this.SET_FORMA_PAGAMENTO(this.aVistaOuAPrazo == 'A' ? 'a_vista' : 'a_prazo');
                this.buscarNegociacoes();
            },

            typePayment() {
                this.buscarNegociacoes();
            },
        },

        beforeMount() {
            this.retornarPreCodigoPorDivida();
            this.buscarNegociacoes();
        },

        mounted() {
            this.action_salvar_etapa({
                pes_codigo: this.divida.pes_codigo,
                esn_fk_ets_codigo: 34,
                emp_codigo: this.parceiroConfig.emp_codigo,
                loj_codigo: this.divida.loj_codigo,
            });

            this.aVistaOuAPrazo = this.formaPagamentoChar;
        },

        methods: {
            ...mapMutations(["SET_FORMA_PAGAMENTO", "SET_FORMA_PAGAMENTO_CHAR"]),

            ...mapActionsPassosRetornarDividas(["acaoPasso3ConsultarNegociacoes"]),

            retornarPreCodigoPorDivida() {
                let contratos = null;

                this.preCodigo = [];
                contratos = this.divida.contratos;

                for (const contrato in contratos) {
                    for (const parcela in contratos[contrato].parcelas) {
                        this.preCodigo.push(
                            contratos[contrato].parcelas[parcela].pre_codigo[this.formaPagamento]
                        );
                    }
                }
            },

            verificarData() {
                const dataInput = new Date(this.primeiroVencimento);
                const dataDeHojeEmDate = new Date(this.dataDeHoje);
                const dataLimite = new Date(this.dataLimite);

                let ehMenorDoQueDataMinima =
                    dataInput.getTime() < dataDeHojeEmDate.getTime();
                let ehMaiorDoQueDataMaxima =
                    dataInput.getTime() > dataLimite.getTime();

                let dataLimiteFormatada = this.dataLimite
                    .split("-")
                    .reverse()
                    .join("/");

                if (ehMenorDoQueDataMinima || ehMaiorDoQueDataMaxima) {
                    this.CHANGE_MESSAGE_MODAL({
                        show: true,
                        title: "Erro",
                        message: `Data de vencimento passada é inválida, a data máxima possível é: ${dataLimiteFormatada}`,
                        styleMessage: "danger",
                    });
                    this.primeiroVencimento = this.dataDeHoje;
                    return false;
                } else {
                    this.primeiroVencimentoAnterior = this.primeiroVencimento;
                }
                return true;
            },

            buscarNegociacoes() {
                this.retornarPreCodigoPorDivida();
                if (
                    (this.aVistaOuAPrazo === "A" || this.aVistaOuAPrazo === "P") &&
                    this.verificarData()
                ) {
                    this.parcelas = [];

                    this.acaoPasso3ConsultarNegociacoes({
                        lojCodigo: this.divida.loja.loj_codigo,
                        preCodigo: this.preCodigo,
                        primeiroVencimento: this.primeiroVencimento,
                        pagamentoAvistaPrazo: this.aVistaOuAPrazo,
                        jurosParcelamento: this.divida.loja.lop_minimo_juros,
                        formaPagamento: this.typePayment,
                    })
                        .then((resposta) => {
                            if (resposta) {

                                this.parcelas = [];
                                // alterações feitas para o portal mostrar os mesmos valores do CRM
                                Object.keys(resposta.mensagem).forEach((praCodigo) => {
                                    if (praCodigo !== "valor_total_pro_cartao") {
                                        let valorEntrada = 0;
                                        if (
                                            resposta.mensagem[praCodigo]
                                                .pra_valor_entrada === null ||
                                            resposta.mensagem[praCodigo]
                                                .pra_valor_entrada === 0 ||
                                            resposta.mensagem[praCodigo]
                                                .pra_valor_entrada <
                                            resposta.mensagem[praCodigo]
                                                .valor_por_parcelas
                                        ) {
                                            valorEntrada =
                                                resposta.mensagem[praCodigo]
                                                    .valor_por_parcelas;
                                        } else {
                                            valorEntrada =
                                                resposta.mensagem[praCodigo]
                                                    .pra_valor_entrada;
                                        }

                                        this.parcelas.push({
                                            pra_codigo: praCodigo,
                                            pra_valor_entrada: valorEntrada,
                                            pra_primeiro_vcto:
                                                resposta.mensagem[praCodigo]
                                                    .pra_primeiro_vcto,
                                            pra_quantidade:
                                                resposta.mensagem[praCodigo]
                                                    .pra_quantidade,
                                            pra_valor_parcela:
                                                resposta.mensagem[praCodigo]
                                                    .valor_por_parcelas == 0 ||
                                                    resposta.mensagem[praCodigo]
                                                        .valor_por_parcelas == undefined
                                                    ? resposta.mensagem[praCodigo]
                                                        .pra_valor_parcela
                                                    : resposta.mensagem[praCodigo]
                                                        .valor_por_parcelas,
                                            valor_total_acordo:
                                                resposta.mensagem[praCodigo]
                                                    .valor_total_acordo == 0 ||
                                                    resposta.mensagem[praCodigo]
                                                        .valor_total_acordo == undefined
                                                    ? resposta.mensagem[praCodigo]
                                                        .pra_valor_parcela
                                                    : resposta.mensagem[praCodigo]
                                                        .valor_total_acordo,
                                        });
                                    }
                                });

                                if (
                                    this.aVistaOuAPrazo == "A" &&
                                    this.parcelas.length > 1
                                ) {
                                    this.parcelas.splice(1, this.parcelas.length - 1);
                                }

                                if (this.aVistaOuAPrazo == "P") {
                                    this.parcelas.shift();
                                }
                            }
                        })
                        .catch((_) => {
                            this.CHANGE_MESSAGE_MODAL({
                                show: true,
                                title: "Erro",
                                message: "Não foi possível encontrar negociações",
                                styleMessage: "danger",
                            });
                        });
                }
            },
        },
    };
</script>

<style scoped>
    .containerDebitDetail {
        width: 100%;
        box-sizing: border-box;
        max-width: 750px;
        padding: 30px;
        background: var(--whiteColor);
        border-radius: 40px;
        box-shadow: 0 1px 2px rgba(3, 27, 78, 0.16);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        margin-bottom: 100px;
    }

    .header-debits {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        box-sizing: border-box;
        width: 100%;
        max-width: 750px;
        cursor: pointer;
    }

    h3 {
        margin: 30px 0px;
        color: #031b4e;
        font-family: "Roboto Black";
        text-transform: uppercase;
        font-size: 16px;
        text-align: center;
    }

    h4 {
        margin: 30px 0px;
        color: #031b4e;
        font-family: "Roboto";
        text-align: center;
    }

    .header-debits i {
        font-size: 48px;
        color: #031b4e;
    }

    .row-buttons {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .container-option-payment {
        padding: 30px 0;
        max-height: 500px;
        overflow-y: auto;
    }

    .container-option-payment::-webkit-scrollbar {
        width: 5px;
        height: 0;
    }

    .container-option-payment::-webkit-scrollbar-thumb {
        background: #9a9a9a;
    }

    .row-tabs {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        margin: 0 0 0 0;
    }

    .tab {
        width: 100%;
        text-align: center;
        font-size: 16px;
        text-transform: uppercase;
        padding: 10px 0;
        border-bottom: 3px solid transparent;
        font-family: "Roboto Black";
        color: #9a9a9a;
    }

    .tab.active {
        border-bottom: 3px solid var(--color);
        font-family: "Roboto Black";
        color: var(--color);
    }

    .tab:hover {
        cursor: pointer;
    }

    .message-empty {
        text-align: center;
        padding: 40px 0;
        font-size: 14px;
        font-family: Roboto;
        color: #5b6987;
    }

    .row-options-buttons {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .row-options-buttons div {
        padding: 0 2px;
        margin-bottom: 5px;
    }

    .checkBoxFuturePayment {
        margin: 10px 0px;
        color: #031b4e;
        font-family: "Roboto Black";
        text-transform: uppercase;
        font-size: 16px;
        text-align: center;
    }

    @media only screen and (max-width: 600px) {
        .row-options-buttons {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
        }

        .row-options-buttons div {
            padding: 0px;
            margin-bottom: 5px;
            width: 100%;
        }
    }

    .opcoes_de_pagamento {
        display: flex;
        justify-content: space-around;
    }

    .opcoes_de_pagamento label {
        font-size: 16px;
        font-family: "Roboto Black";
        color: #031b4e;
    }

    #div-data-primeiro-vencimento {
        margin: 20px 0px;
        display: flex;
        flex-direction: column;
        align-self: center;
        align-items: center;
    }

    #div-data-primeiro-vencimento label {
        color: #031b4e;
        font-family: "Roboto Black";
        font-size: 16px;
    }

    #input-data-primeiro-vencimento {
        border-radius: 25px;
        border: 3px solid #031b4e;
        width: 200px;
        margin-top: 20px;
        float: right;
    }

    .hide {
        display: none;
    }
</style>
